import Parse from "parse";

export function verifyPaddleActivationToken(activationToken) {
  return Parse.Cloud.run("verifyPaddleActivationToken", { activationToken });
}

export function applyPaddleActivationToken(activationToken) {
  return Parse.Cloud.run("applyPaddleActivationToken", { activationToken });
}

export function generateNoTrialLink(productId) {
  return Parse.Cloud.run("generatePaddleNoTrialCheckoutLink", {
    productId,
    shouldRedirect: false
  });
}

export function createTemporarySubscription(productId) {
  return Parse.Cloud.run("createTemporarySubscription", { productId });
}

export function redeemHotelTabletOffer({ hotelName, tabletProvider }) {
  return Parse.Cloud.run("redeemHotelTabletOffer", {
    hotelName,
    tabletProvider
  });
}
